<ng-container *ngIf="window === 'A'; else windowB">
  <div class="pme-container">
    <pme-window-shop-manager-header *ngIf="this.headerContent" [headerContent]="this.headerContent">
    </pme-window-shop-manager-header>

    <div class="product-listing-header" *ngIf="this.productListing" [innerHTML]="this.productListing.title"></div>

    <!--PRODUCT LISTING-->
    <!--Desktop view-->
    <div class="display-utils-row display-utils-lt-md-col display-utils-start-center"
      *ngIf="stackingOnePackage && selectedToggle === 0 && stackingOnePackageMessage">
      <div class="display-utils-center-center display-utils-gap-20 display-utils-flex-100">
        <div class="warning-stacking-one-card">
          <div class="display-utils-row display-utils-center-center display-utils-gap-16 display-utils-sm-gap-8 display-utils-md-gap-16">
            <img src="../../../assets/images/dialog-icons/warn-badge.svg">
            <div class="display-utils-row display-utils-lt-sm-col display-utils-center-center display-utils-xs-start-start display-utils-gap-16 display-utils-xs-gap-4 display-utils-sm-gap-8 display-utils-md-gap-12">
              <span>
                <strong>Atenção</strong>
              </span>
              <p [innerHTML]="stackingOnePackageMessage"></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="display-utils-row display-utils-lt-md-col display-utils-center-center display-utils-gap-16 display-utils-only-gt-xs"
      style="margin-top: 16px;" *ngIf="classificationsGetted === 2">

      <div class="display-utils-lt-md-flex-100 display-utils-gt-md-flex-15">
        <p>Escolha seu pacote de créditos:</p>
      </div>

      <div class="pme-carousel-swiper-container display-utils-lt-md-flex-100 display-utils-gt-md-flex-85">

        <ng-container *ngIf="packages && !stackingOnePackage">
          <pme-carousel-swiper-consulta [identifier]="'consulta-products'" [items]="packages">
            <ng-template let-product let-i="index">
              <pme-product-consulta [productData]="product" (buyClicked)="navigate(i)"
                [oneClickPurchaseInfo]="this.oneClickPurchaseInfo" [idOneClick]="'oneClick' + i" [elementIndex]="i"
                (exibirBalaoOneClick)="criarBalaoOneClick($event.info, $event.index, $event.position)"
                (esconderBalaoOneClick)="esconderBalaoOneClick()"></pme-product-consulta>
            </ng-template>
          </pme-carousel-swiper-consulta>
        </ng-container>

        <ng-container *ngIf="packages && stackingOnePackage">
          <pme-carousel-swiper [identifier]="'consulta-products'" [items]="packages">
            <ng-template let-product let-i="index">
              <pme-product-consulta [productData]="product" (buyClicked)="navigate(i)"
                [oneClickPurchaseInfo]="this.oneClickPurchaseInfo" [idOneClick]="'oneClick' + i" [elementIndex]="i"
                (exibirBalaoOneClick)="criarBalaoOneClick($event.info, $event.index, $event.position)"
                (esconderBalaoOneClick)="esconderBalaoOneClick()"></pme-product-consulta>
            </ng-template>
          </pme-carousel-swiper>
        </ng-container>

      </div>
    </div>

    <ng-template #balaoOneClickContainer></ng-template>
    <!-- end Desktop view -->

    <!--Mobile view -->
    <div class="display-utils-col display-utils-start-stretch display-utils-hide-gt-xs" style="margin-top: 16px;"
      *ngIf="classificationsGetted === 2">
      <div class="display-utils-flex-100">
        <p style="text-align: center;">Escolha seu pacote de créditos:</p>
      </div>
      <div class="display-utils-col display-utils-start-stretch display-utils-gap-8 display-utils-flex-100" *ngIf="!stackingOnePackage">
        <ng-container *ngIf="packages">
          <pme-product-consulta [productData]="package" *ngFor="let package of packages.slice(0, 3); let i = index"
            (buyClicked)="navigate(i)"
            (exibirBalaoOneClick)="criarBalaoOneClick($event.info, $event.index, $event.position)"></pme-product-consulta>
        </ng-container>
        <div class="highlight-wrapper">
          <div class="discount-badge">
            <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.65632 17.8356L0.497986 9.6773V11.344C0.497986 11.7856 0.672986 12.2106 0.989652 12.519L7.48132 19.0106C8.13132 19.6606 9.18965 19.6606 9.83965 19.0106L15.0147 13.8356C15.6647 13.1856 15.6647 12.1273 15.0147 11.4773L8.65632 17.8356Z"
                fill="#E63888" />
              <path
                d="M7.48132 14.844C7.80632 15.169 8.23132 15.3356 8.65632 15.3356C9.08132 15.3356 9.50632 15.169 9.83132 14.844L15.0063 9.66897C15.6563 9.01897 15.6563 7.96063 15.0063 7.31063L8.51465 0.818966C8.20632 0.510632 7.78132 0.335632 7.33965 0.335632H2.16465C1.24799 0.335632 0.497986 1.08563 0.497986 2.0023V7.1773C0.497986 7.61897 0.672986 8.04397 0.989652 8.3523L7.48132 14.844ZM2.16465 2.0023H7.33965L13.8313 8.49397L8.65632 13.669L2.16465 7.1773V2.0023Z"
                fill="#E63888" />
              <path
                d="M4.03965 4.91897C4.61495 4.91897 5.08132 4.4526 5.08132 3.8773C5.08132 3.302 4.61495 2.83563 4.03965 2.83563C3.46436 2.83563 2.99799 3.302 2.99799 3.8773C2.99799 4.4526 3.46436 4.91897 4.03965 4.91897Z"
                fill="#E63888" />
            </svg>
            <p class="discount-badge-text">Pacotes com desconto progressivo nas consultas!</p>
          </div>
          <div class="products-container">
            <ng-container *ngIf="packages">
              <pme-product-consulta [productData]="package" *ngFor="let package of packages.slice(3); let i = index"
                (buyClicked)="navigate(i + 3)"
                (exibirBalaoOneClick)="criarBalaoOneClick($event.info, $event.index, $event.position)"></pme-product-consulta>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="display-utils-col display-utils-start-stretch display-utils-gap-8 display-utils-flex-100" *ngIf="stackingOnePackage">
        <ng-container *ngIf="packages">
          <pme-product-consulta [productData]="package" *ngFor="let package of packages; let i = index"
            (buyClicked)="navigate(i)"
            (exibirBalaoOneClick)="criarBalaoOneClick($event.info, $event.index, $event.position)"></pme-product-consulta>
        </ng-container>
      </div>
    </div>
    <!-- end Mobile view -->
    <div *ngIf="this.productListing" [innerHTML]="this.productListing.footer" class="product-listing-footer"></div>
    <!-- end Product Listing -->


    <mat-divider class="divider" *ngIf="this.tableNutritionContent"></mat-divider>

    <pme-window-shop-manager-nutrition-table *ngIf="this.tableNutritionContent"
      [tableNutritionContent]="this.tableNutritionContent"></pme-window-shop-manager-nutrition-table>

    <mat-divider class="divider"></mat-divider>
    <pme-payment-methods></pme-payment-methods>
    <mat-divider class="divider"></mat-divider>
  </div>
</ng-container>

<ng-template #windowB>
  <div class="pme-container">
    <pme-window-shop-manager-header *ngIf="this.headerContent" [headerContent]="this.headerContent">
    </pme-window-shop-manager-header>

    <div class="product-listing-header" *ngIf="this.productListing" [innerHTML]="this.productListing.title"></div>

    <pme-switch-consulta-assinatura [selectedToggle]="selectedToggle"
      (onSelectionChanged)="onSelectionChanged($event)"></pme-switch-consulta-assinatura>

    <div class="display-utils-row display-utils-lt-md-col display-utils-start-center"
      *ngIf="stackingOnePackage && selectedToggle === 1 && stackingOnePackageMessage">
      <div class="display-utils-center-center display-utils-gap-20 display-utils-flex-100">
        <div class="warning-stacking-one-card">
          <div class="display-utils-row display-utils-center-center display-utils-gap-16 display-utils-sm-gap-8 display-utils-md-gap-16">
            <img src="../../../assets/images/dialog-icons/warn-badge.svg">
            <div class="display-utils-row display-utils-lt-sm-col display-utils-center-center display-utils-xs-start-start display-utils-gap-16 display-utils-xs-gap-4 display-utils-sm-gap-8 display-utils-md-gap-12">
              <span>
                <strong>Atenção</strong>
              </span>
              <p [innerHTML]="stackingOnePackageMessage"></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--PRODUCT LISTING-->
    <!--Desktop view-->
    <div class="display-utils-only-gt-xs" style="margin-top: 16px; margin-left: auto; margin-right: auto; width: fit-content;">
      <div *ngIf="selectedToggle === 0" class="products display-utils-row display-utils-center-flexstart">
        <pme-assinatura-product class="subscriberPlans" [ngClass]="{'start': i === 0, 'end': i === (plans.length -1)}"
          [plan]="assinatura" [activePlanIdentifier]="activePlanIdentifier" [activePlanValue]="activePlanValue"
          *ngFor="let assinatura of plans;let i = index" (buyClicked)="navigate(i, $event)"></pme-assinatura-product>
      </div>

      <div *ngIf="selectedToggle === 1" class="products display-utils-row display-utils-center-flexstart">
        <pme-consulta-product-selector [packages]="packages" (buyClicked)="navigate($event.i, $event.customValue)">
        </pme-consulta-product-selector>
      </div>

      <div *ngIf="this.productListing?.footer" [innerHTML]="this.productListing.footer" class="product-listing-footer">
      </div>
    </div>
    <!-- end Desktop view -->

    <!--Mobile view -->
    <div class="display-utils-hide-gt-xs" style="margin-top: 16px;">
      <div class="productsMobile" *ngIf="selectedToggle === 0">
        <pme-packages-mobile [packages]="plans" [isPlan]="true" [activePlanIdentifier]="activePlanIdentifier"
          [activePlanValue]="activePlanValue" (buyClicked)="navigate($event.i, $event.customValue)">
        </pme-packages-mobile>
      </div>
      <div class="productsMobile" *ngIf="selectedToggle === 1">
        <pme-packages-mobile [packages]="packages" [isPlan]="false"
          (buyClicked)="navigate($event.i, $event.customValue)"></pme-packages-mobile>
      </div>
      <div *ngIf="this.productListing?.footer" [innerHTML]="this.productListing.footer" class="product-listing-footer">
      </div>
    </div>
    <!-- end Mobile view -->
    <!-- <div *ngIf="this.productListing" [innerHTML]="this.productListing.footer" class="product-listing-footer"></div> -->
    <!-- end Product Listing -->

    <div class="display-utils-only-gt-xs" *ngIf="this.isHybridPackage">

      <mat-divider class="divider"></mat-divider>

      <ng-container *ngIf="packages && selectedToggle === 0">
        <pme-price-table [shopWindowItems]="packages" (buyClicked)="navigate($event)"></pme-price-table>
      </ng-container>

      <ng-container *ngIf="plans && selectedToggle === 1">
        <pme-price-table [shopWindowItems]="this.plans" (buyClicked)="navigate($event)"></pme-price-table>
      </ng-container>

    </div>


    <mat-divider class="divider" *ngIf="this.tableNutritionContent"></mat-divider>

    <!-- <pme-window-shop-manager-nutrition-table *ngIf="this.tableNutritionContent"
    [tableNutritionContent]="this.tableNutritionContent"></pme-window-shop-manager-nutrition-table> -->

    <!-- <mat-divider class="divider"></mat-divider> -->
    <pme-window-shop-manager-nutrition-table *ngIf="this.tableNutritionContent"
      [tableNutritionContent]="this.tableNutritionContent"></pme-window-shop-manager-nutrition-table>
    <mat-divider class="divider" *ngIf="legalNotes?.length"></mat-divider>
    <div *ngIf="legalNotes?.length">
      <ul>
        <li *ngFor="let note of legalNotes" style="font-size: 14px; font-family: Roboto;">
          {{ note }}
        </li>
      </ul>
    </div>
    <mat-divider class="divider"></mat-divider>
    <pme-payment-methods></pme-payment-methods>
    <mat-divider class="divider"></mat-divider>
  </div>
</ng-template>